@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="listingsPublicationStatusSegments()"
            [centerLabel]="listingsPublicationStatusCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="listingsPublicationStatusSegments()"
        [centerLabel]="listingsPublicationStatusCenterLabel()"
        [valueColumnHeader]="'dashboard.visuals.widgets.listingsPublicationStatus.tableLabel' | translate"
        [labelColumnHeader]="'dashboard.visuals.widgets.listingsPublicationStatus.statusLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    />
}
